import React from 'react'
import Table from 'react-bootstrap/Table';
import Footer from './footer';

export default function Contacts() {
  return (
    <>
        <div className='cont-text'>
            <br />
            <br />
            <h1 className="text-center">Contacts</h1><br/>
            <h3>Sales and General Enquiries</h3>
            <br />
            <p>If you would like to discuss your purchasing interest with Bentley Motors directly or have a general query, please contact us on one of the following numbers:</p>
        </div>
        <Table striped bordered hover>
            <thead>
                <tr>
                <th>#</th>
                <th>REGIONS</th>
                <th>CONTACT NUMBERS</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                <td>1</td>
                <td>United Kingdom</td>
                <td>+44 (0) 1270 653 653</td>
                </tr>
                <tr>
                <td>2</td>
                <td>United States</td>
                <td>+1 800 777 6923</td>
                </tr>
                <tr>
                <td>3</td>
                <td>Europe</td>
                <td>+44 (0) 1270 653 653</td>
                </tr>
                <tr>
                <td>4</td>
                <td>China</td>
                <td>+86 400 119 8880</td>
                </tr>
                <tr>
                <td>5</td>
                <td>Japan</td>
                <td>0120 97 7797 (only available inside Japan)</td>
                </tr>
                <tr>
                <td>6</td>
                <td>South Korea</td>
                <td>+82 (0)2 3448 2700</td>
                </tr>
                <tr>
                <td>7</td>
                <td>South East Asia & Australasia</td>
                <td>+61 280466202</td>
                </tr>
                <tr>
                <td>8</td>
                <td>Rest of the World</td>
                <td>+44 (0) 1270 535 032</td>
                </tr>
            </tbody>
        </Table>
        <Footer/>
    </>
  )
}
